export default "__VITE_PUBLIC_ASSET__fc2f6828__"